import styled from 'styled-components';
import * as RTable from 'react-super-responsive-table';
import { tokens } from '../../../../../design/tokens';

export const StyledTable = styled(RTable.Table)`
  width: 100%;
  margin-top: ${tokens.space.md};
`;

export const StyledTd = styled(RTable.Td)`
  padding: ${tokens.space.lg};
  text-align: center;
  font-weight: 600;
  font-family: ${tokens.font.body.family};
  color: ${tokens.color.textWhite};
`;
